<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择物料标签模板"
      width="50%"
      top="5vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="materialLabelPrints/page/template"
        @select="onSelect"
        @reset="resetHandle">
      <template #adSearch>
        <el-form :inline="true" :model="filter" @keyup.enter.native="getList(1)">
          <el-form-item label="模板名称">
            <el-input v-model.trim="filter.templateName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-input v-model.trim="filter.templateTypeName" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    name: "MaterialLabelPrintTemplateSelect",
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        columns: [
          {
            title: "模板名称",
            key: "name",
            align: "center",
          },
          {
            title: "模板类型",
            key: "typeName",
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
        filter: {
          templateTypeName: "",
          templateName: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData(1);
        });
      },
      getList(pageNum) {
        this.$refs.tableSelect.loadData(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
